import { mainInstance } from "api";
import { PAGE_SIZE } from "utils/Constans";

const getAssignments = async (
  { filterBody, schoolId, semesterId, pageSize = PAGE_SIZE },
  page
) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/Assignment?SemesterId=${semesterId}&SchoolId=${schoolId}&PageIndex=${page}&PageSize=${pageSize}&SchoolClassId=${
      filterBody?.schoolClass || ""
    }&ClassBaseId=${filterBody?.classBase || ""}&Title=${
      filterBody?.name || ""
    }&StartDate=${filterBody?.date || ""}&CourseId=${filterBody?.course || ""}`
  );
  return data.data;
};

const deleteAssignment = async ({ semesterId, assignmentId }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/Assignment/${semesterId}/${assignmentId}`
  );
  return data.data;
};

const copyAssignment = async ({ semesterId, schoolId, assignmentId }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/Assignment/${schoolId}/${semesterId}/${assignmentId}/Copy`
  );
  return data.data;
};

const postQuestionList = async ({
  body,
  semesterId,
  isRelease,
  assignmentId,
}) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/AssignmentQuestion/Assignments/${semesterId}/${assignmentId}/PostList/${isRelease}`,
    body
  );
  return data.data;
};

const getAssignmentResults = async (
  { body, semesterId, schoolId, assignmentId },
  page
) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/AssignmentResults/${semesterId}/${schoolId}/${assignmentId}/GetAll`,
    { ...body, pageIndex: page }
  );
  return data.data;
};

const deleteAssignmentResult = async ({
  assignmentId,
  studentId,
  assignmentResultId,
}) => {
  const { data } = await mainInstance.delete(
    `api/teacher/v3.0/AssignmentResults/${assignmentId}/${studentId}/${assignmentResultId}`
  );
  return data.data;
};

const getAssignmentDetail = async ({ semesterId, assignmentId }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/Assignment/${semesterId}/${assignmentId}`
  );
  return data.data;
};

const getAssignmentDetailWitchClasses = async ({ assignmentId }) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/Assignment/${assignmentId}/DetailsWithClasses`
  );
  return data.data;
};

const getAssignemntResultCount = async ({
  semesterId,
  schoolId,
  assignmentId,
}) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/Assignment/${schoolId}/${semesterId}/${assignmentId}/CountResult`
  );
  return data.data;
};

const editQuestionList = async ({ body, semesterId, assignmentId }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/AssignmentQuestion/Assignments/${semesterId}/${assignmentId}/PatchList`,
    body
  );
  return data.data;
};
const postAssignment = async ({ body }) => {
  const { data } = await mainInstance.post(
    `/api/teacher/v3.0/Assignment`,
    body
  );
  return data.data;
};
const editAssignment = async ({ body }) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/Assignment`,
    body
  );
  return data.data;
};
const deleteQuestionAssignment = async ({ id }) => {
  const { data } = await mainInstance.delete(
    `/api/teacher/v3.0/AssignmentQuestion/${id}`
  );
  return data.data;
};
const postAssignmentCorrection = async ({
  body,
  schoolId,
  semesterId,
  studentId,
  assignmentResultId,
}) => {
  const { data } = await mainInstance.patch(
    `/api/teacher/v3.0/AssignmentResults/${schoolId}/${semesterId}/Correction/${studentId}/${assignmentResultId}`,
    body
  );
  return data.data;
};
const getAssignmentStudentResultDetail = async ({
  semesterId,
  studentId,
  assignmentId,
}) => {
  const { data } = await mainInstance.get(
    `/api/teacher/v3.0/AssignmentResults/${semesterId}/${assignmentId}/${studentId}/Details`
  );
  return data.data;
};

export {
  deleteAssignmentResult,
  getAssignments,
  deleteAssignment,
  copyAssignment,
  postQuestionList,
  getAssignmentResults,
  getAssignmentDetail,
  getAssignmentDetailWitchClasses,
  getAssignemntResultCount,
  editQuestionList,
  postAssignment,
  editAssignment,
  deleteQuestionAssignment,
  getAssignmentStudentResultDetail,
  postAssignmentCorrection,
};
